import logo from './assets/logo-v2.png';

import './styling/App.scss';

function App() {
    return (
        <div className='sorso-landing'>
            <h1 className='sorso-title'>Download</h1>
            <img className='sorso-logo' src={logo} alt='Sorso logo'/>
        </div>
    );
}

export default App;
